export default "__VITE_ASSET__CAL3ZJRw__"